export default {
    getVolunteerData(state) {
        return state.volunteerData;
    },
    isVolunteerDataResolved(state) {
        return state.volunteerDataResolved;
    },
    getTeamMembers(state) {
        return state.teamMembers;
    },
    getVolunteers(state) {
        return state.volunteers;
    }
}